import { ComponentState } from '../../../types/ComponentStates.types';
import { LabeledComponent, LabeledComponentProperties, LabeledComponentProps } from '../inputs/LabeledComponent';
import AutocompleteDropdown, { AutocompleteDropdownProps } from './AutocompleteDropdown';

interface LabeledProps extends Omit<LabeledComponentProps, 'children'> {
  errorMessage?: string | undefined;
}

interface LabeledStateAutocompleteDropdownProps {
  id: string;
  state: ComponentState;

  labeledProps: LabeledProps;
  dropdownProps: AutocompleteDropdownProps;
}

export const LabeledStateAutocompleteDropdown = ({
  id,
  labeledProps,
  dropdownProps,
  state,
}: LabeledStateAutocompleteDropdownProps) => {
  const { errorMessage, stateProperties: labeledStateProperties } = labeledProps;

  const myStateProperties: LabeledComponentProperties = {
    error: {
      message: errorMessage,
      color: 'text-error',
    },
    default: {},
    ...labeledStateProperties,
  };

  const labeledComponentProps = {
    id,
    state,
    stateProperties: myStateProperties,
    ...labeledProps,
  };

  return (
    <LabeledComponent {...labeledComponentProps}>
      <AutocompleteDropdown {...dropdownProps} />
    </LabeledComponent>
  );
};
